import { render, staticRenderFns } from "./CsvExport.vue?vue&type=template&id=0b2870cc&"
import script from "./CsvExport.vue?vue&type=script&lang=js&"
export * from "./CsvExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports